<template lang="pug">
.icon.d-flex.flex-column.align-items-center
  .circle
    img(:src="content.photo.image")
  p {{ content.title }}
</template>

<script>
export default {
  name: "Icon",
  props: {
    content: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/icon";
</style>
